import { Injectable, EventEmitter } from '@angular/core';
import { Nav } from './nav.interface';


interface NavModel {
  navs: Nav[];
  active?: Nav;
}

@Injectable()
export class NavService {

  select: EventEmitter<Nav> = new EventEmitter();

  model: NavModel = {
    navs: []
  };


  addNav(nav: Nav): void {
    this.model.navs.push(nav);
    if (nav.active) { this.model.active = nav; }
  }

  selectNav(nav: Nav): void {
    this.model.navs.forEach((_nav: Nav) => {
        _nav.active = false;
    });
    nav.active = true;
    this.model.active = nav;
    this.select.emit(nav);
  }

  reset(): void {
    this.model.navs = [];
  }
}
